const addSpacesInString = (string, length = 10) => {
  if (string.length < length) return string;
  let stringWithSpace = "";
  for (let i = 0; i< string.length; i = i + length) {
    stringWithSpace = stringWithSpace + string.substring(i, i + length) + " ";
  }
  return stringWithSpace;
}

export default addSpacesInString;